export const podcastsList = [
    {
        title: "KATAGLYPHS SERIES (2020)",
        url: "https://m.youtube.com/playlist?list=PL-aeTqwGNTmSFmfVNgsUCJr4aqZTyppRi",
    },
    {
        title: "Water The Bamboo with Greg Bell",
        url: "https://podcasts.apple.com/us/podcast/water-the-bamboo-unleashing-your-potential/id1540399517#episodeGuid=32aadf37-f43a-4764-83df-aae014715181",
    },
    {
        title: "JON GORDON – Positve U",
        url: "https://positiveuniversity.com/episode/kevin-carroll/",
    },
    {
        groupTitle: "A Tribe Called YES!",
        groupItems: [
            {
                title: "Episode 50",
                url: "http://www.stitcher.com/podcast/a-tribe-called-yes-with-daron-k-roberts/e/52148190?autoplay=true",
            },
            {
                title: "Episode51",
                url: "http://www.stitcher.com/podcast/a-tribe-called-yes-with-daron-k-roberts/e/52301136",
            },
        ]
    },
    {
        groupTitle: "Army of Game Changers Podcast! (Feb 2018)",
        groupItems: [
            {
                title: "LinkedIn - shownotes",
                url: "https://www.linkedin.com/pulse/fostering-creativity-leadership-kevin-carroll-vipe-desai/",
            },
            {
                title: "iTunes",
                url: "https://itunes.apple.com/us/podcast/ep-08-kevin-carroll-author-speaker-agent-for-social/id1330029639?i=1000403904695&mt=2",
            },
            {
                title: "Soundcloud",
                url: "https://soundcloud.com/armyofgamechangers/ep-08-kevin-carroll-author-speaker-and-agent-for-social-change",
            },
        ]
    },
    {
        title: "Educated Guess",
        url: "https://www.eventbrite.com/e/the-emotional-cost-of-being-a-creative-tickets-52564666332",
    },
    {
        title: "Finding Mastery",
        url: "https://findingmastery.net/kevin-carroll/",
    },
    {
        title: "Marketing Mentor",
        url: "http://bit.ly/KC-MMpodcast",
    },
    {
        title: "Beyond the Uniform",
        url: "http://bit.ly/2Lfffmh",
    },
    {
        title: "Athletic Greens Inspiring Lives Podcast",
        url: "https://inspiringlives.simplecast.com/episodes/kevin-carroll-the-importance-of-play-curiosity-and-joy",
    },
    {
        title: "Story",
        url: "https://apple.co/2ZwHmHG",
    },
    {
        title: "Living Fearlessly",
        url: "http://traffic.megaphone.fm/CSN5015434558.mp3",
    },
    {
        title: "Rising Coaches",
        url: "https://podcasts.apple.com/us/podcast/the-rising-coaches-podcast/id1210491438",
    },
];


